import Switch from '@material-ui/core/Switch';
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment-timezone';
import { localizationSlice, selectLocalizationState } from 'models/localization';
import { useTranslation } from 'react-i18next';

const RootContainer = styled.div``;

const TimeZoneSwitch = ({ className }: any) => {
  const { t } = useTranslation();
  const { useLocalTime, eventTimezone } = useSelector(createSelector(selectLocalizationState,
    ((state) => ({ useLocalTime: state.useLocalTime, eventTimezone: state.eventTimezone }))));

  const sameTimeZone = moment.tz(moment.tz.guess()).utcOffset() === moment.tz(eventTimezone).utcOffset();

  const dispatch = useDispatch();
  const onToggle = (e) => {
    dispatch(localizationSlice.actions.setUseLocalTime(e.target.checked));
  };
  return (
    !sameTimeZone && (
      <RootContainer className={className}>
        <FormControlLabel
          control={<Switch checked={useLocalTime} onChange={onToggle} />}
          label={<span style={{ fontFamily: "Lato, 'Noto Sans SC', sans-serif" }}>{t('webinar.use_local_time', 'Use Local Time')}</span>}
        />
      </RootContainer>
    )
  );
};

TimeZoneSwitch.defaultProps = {
  className: '',
};

export default TimeZoneSwitch;
